import { Action, Module, Mutation,
  VuexModule } from 'vuex-module-decorators';
import { page } from '@/services/api';

const SET_ABOUT_TRANSLATION = 'SET_ABOUT_TRANSLATION';

const rawError: boolean = true;

@Module({namespaced: true})
export default class AboutPage extends VuexModule {
  public translation = {
    topBanner: {
      image: {},
    },
    headerBgImg: {},
    aboutComplexTexts: {},
    aboutDesignTexts: {},
    aboutServicesTexts: {},
  };

  public get translations(): {} {
    return this.translation;
  }

  public get headerBgImg(): {} {
    return this.translation.headerBgImg;
  }

  public get aboutComplexTexts(): {} {
    return this.translation.aboutComplexTexts;
  }

  public get aboutDesignTexts(): {} {
    return this.translation.aboutDesignTexts;
  }

  public get aboutServicesTexts(): {} {
    return this.translation.aboutServicesTexts;
  }

  @Mutation
  public [SET_ABOUT_TRANSLATION](payload): void {
    this.translation = payload;
  }

  @Action({commit: SET_ABOUT_TRANSLATION, rawError})
  public async fetchTranslation() {
    const data = await page('about');
    return data ? data : this.translation;
  }

}
